import { isNull, get } from "lodash"
import locales from "./../../../content.json"

export const checkIsValidSex = data => {
    return validateSexStep(get(data, ["sex", "value"], "")) && !data.sex.isValid
}

export const validateSexStep = value => {
    return !isNull(value)
}

export const sexData = {
    male: {
        value: "male",
        title: locales[window.userLang].male,
    },
    female: {
        value: "female",
        title: locales[window.userLang].female,
    },
    other: {
        value: "other",
        title: locales[window.userLang].other,
    },
}